import { render, staticRenderFns } from "./teamB.vue?vue&type=template&id=5559ece4&scoped=true&"
import script from "./teamB.vue?vue&type=script&lang=js&"
export * from "./teamB.vue?vue&type=script&lang=js&"
import style0 from "./teamB.vue?vue&type=style&index=0&id=5559ece4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5559ece4",
  null
  
)

export default component.exports